define('modules/news/news_item_model',[
  'backbone',
  '_',
  'session'
], function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    url: function () {
      if (this.has('id')) {
        return session.get('apiUrl') + 'news/' + this.get('id');
      } else {
        return session.get('apiUrl') + 'news/new';
      }
    }
  });

  return Model;
});

